import { getServerSession } from 'modules/auth/server';
import AmbassadorsPage from 'modules/Marketing/pages/Ambassadors';
import UserModel from 'modules/User/models/User';
import type { GetServerSideProps } from 'next';
import dbConnect from 'utils/db';

export const getServerSideProps: GetServerSideProps = async (context) => {
  await dbConnect();
  const session = await getServerSession(context);

  if (context.locale === 'en') {
    return {
      redirect: {
        destination: '/fr/ambassadors',
        permanent: false,
      },
    };
  }

  const ambassadors = await UserModel.find({ ambassadorFor: { $exists: true } })
    .select('_id name firstName lastName image ambassadorFor phone url')
    .sort({ ambassadorFor: 1 })
    .lean({ virtuals: true });

  return {
    props: {
      session: JSON.parse(JSON.stringify(session)),
      ambassadors: JSON.parse(JSON.stringify(ambassadors)),
    },
  };
};

export default AmbassadorsPage;
